import { render } from "./InsertedCoins.vue?vue&type=template&id=1bc16540&scoped=true"
import script from "./InsertedCoins.vue?vue&type=script&lang=js"
export * from "./InsertedCoins.vue?vue&type=script&lang=js"

import "./InsertedCoins.vue?vue&type=style&index=0&id=1bc16540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc16540"]])

export default __exports__